import React, { useEffect, useState } from 'react';

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

const SystemBets = (props) => {
    const [bets, setBets] = useState([]);

    // get list of bets for table
    useEffect(()=>{
        if(props.matches !== null && props.matches !== undefined){
            let tmpBets = [];
            // loop through each season
            const seasons = Object.keys(props.matches);
            for(const season of seasons){
                const sznBets = props.matches[season];
                tmpBets = tmpBets.concat(sznBets);
            };
            // Sort tmpBets by date in descending order
            tmpBets.sort((a, b) => {
                // Compare date strings directly; newer dates will be "greater" as strings
                return b.date.localeCompare(a.date);
            });
            setBets(tmpBets);
        };
    }, [props.matches]);

    return (
        <div className="w-full">
            <div className="min-w-full">
                <table className="min-w-full divide-y divide-gray-300 dark:divide-gray-700">
                    <thead>
                        <tr>
                            <th
                                scope="col"
                                className="sticky top-0 z-10 border-b border-gray-300 bg-white/75 dark:bg-gray-800/75 py-2 pr-3 pl-2 text-left text-sm font-semibold text-gray-900 dark:text-white backdrop-blur-sm backdrop-filter"
                            >
                                Game
                            </th>
                            <th
                                scope="col"
                                className="sticky top-0 z-10 border-b border-gray-300 bg-white/75 dark:bg-gray-800/75 px-3 py-2 text-left text-sm font-semibold text-gray-900 dark:text-white backdrop-blur-sm backdrop-filter"
                            >
                                Bet
                            </th>
                            <th
                                scope="col"
                                className="sticky top-0 z-10 border-b border-gray-300 bg-white/75 dark:bg-gray-800/75 px-3 py-2 text-left text-sm font-semibold text-gray-900 dark:text-white backdrop-blur-sm backdrop-filter"
                            >
                                Odds
                            </th>
                            <th
                                scope="col"
                                className="sticky top-0 z-10 border-b border-gray-300 bg-white/75 dark:bg-gray-800/75 px-3 py-2 text-left text-sm font-semibold text-gray-900 dark:text-white backdrop-blur-sm backdrop-filter"
                            >
                                Result
                            </th>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-200 dark:divide-gray-700">
                        {bets.length > 0 ? (
                            bets.map((bet, betIdx) => (
                                <tr key={betIdx}>
                                    <td className="py-3 pr-3 pl-2">
                                        <div className="flex flex-col">
                                            <span className="text-sm font-medium text-gray-900 dark:text-white">
                                                {bet.date}
                                            </span>
                                            <span className="text-sm text-gray-500 dark:text-gray-400">
                                                {bet.game}
                                            </span>
                                        </div>
                                    </td>
                                    <td className="px-3 py-3 text-sm text-gray-900 dark:text-white">
                                        {bet.bet.bet}
                                    </td>
                                    <td className="px-3 py-3 text-sm font-medium">
                                        <span className="text-gray-900 dark:text-white">
                                            {bet.bet.odds > 0 ? "+" : ""}{bet.bet.odds}
                                        </span>
                                    </td>
                                    <td className="px-3 py-3 text-sm font-medium">
                                        <span className={classNames(
                                            'inline-flex items-center rounded-md px-2 py-1 text-xs font-medium',
                                            bet.bet.result === 'W' ? 'bg-green-50 text-green-700 dark:bg-green-900/50 dark:text-green-400' :
                                            bet.bet.result === 'L' ? 'bg-red-50 text-red-700 dark:bg-red-900/50 dark:text-red-400' :
                                            'bg-gray-50 text-gray-700 dark:bg-gray-800 dark:text-gray-300'
                                        )}>
                                            {bet.bet.result}
                                        </span>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="4" className="px-3 py-3 text-sm text-gray-500 dark:text-gray-400 text-center">
                                    No bets found
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default SystemBets;